import { render, staticRenderFns } from "./PcHomeNew1.vue?vue&type=template&id=04cc3dbb&scoped=true&"
import script from "./PcHomeNew1.vue?vue&type=script&lang=js&"
export * from "./PcHomeNew1.vue?vue&type=script&lang=js&"
import style0 from "./PcHomeNew1.vue?vue&type=style&index=0&id=04cc3dbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04cc3dbb",
  null
  
)

export default component.exports